import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getPresignedUrlFileName',
  standalone: true,
})
export class GetPresignedUrlFileNamePipe implements PipeTransform {
  transform(url: string): string | null {
    const match = url.match(/([^/]+)(?=\?)/);
    const fileName = match ? match[0].replace(/%20/g, ' ') : '';
    return fileName;
  }
}
